import { Anchor, Button, Modal, Slider, Text } from '@mantine/core';
import type { GetInputPropsReturnType } from '@mantine/form';
import { IconMail } from '@tabler/icons-react';
import { IconRocket } from '@tabler/icons-react';
import { useState } from 'react';

const MARKS = [
  { value: 0, label: Math.pow(2, 0) },
  { value: 1, label: Math.pow(2, 1) },
  { value: 2, label: Math.pow(2, 2) },
  { value: 3, label: Math.pow(2, 3) },
  { value: 4, label: Math.pow(2, 4) },
  { value: 5, label: Math.pow(2, 5) },
  { value: 6, label: Math.pow(2, 6) },
  { value: 7, label: Math.pow(2, 7) },
  { value: 8, label: Infinity },
];

export function WorkerCountSlider({ value, onChange, max, ...props }: GetInputPropsReturnType & { max?: number }) {
  const realValue = Math.log2(value ?? 1);
  const maxIndex = Math.log2(max ?? 1);

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Modal
        centered
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Unlock Hyperspeed Testing"
        zIndex={300}
      >
        <div className="flex flex-col items-center gap-4 p-4 text-center">
          <div className="rounded-full bg-blue-100 p-4 dark:bg-blue-900/50">
            <IconRocket
              size={48}
              strokeWidth={1.5}
              className="text-blue-600 dark:text-blue-400"
            />
          </div>
          <div className="flex flex-col gap-1">
            <Text
              size="lg"
              fw={600}
            >
              Need more than {max} parallel workers?
            </Text>
            <Text c="dimmed">
              Our enterprise plans provide dedicated infrastructure for maximum performance and infinite scalability.
            </Text>
          </div>

          <div className="mt-4 flex w-full flex-col items-center gap-3">
            <Button
              component="a"
              variant="filled"
              fullWidth
              href="mailto:help@stably.ai?subject=Request for More Parallel Workers"
              size="sm"
              onClick={() => setIsModalOpen(false)}
            >
              Reach out to us
            </Button>
            <Anchor
              href="mailto:help@stably.ai"
              c="dimmed"
              size="xs"
              className="inline-flex items-center gap-1 transition-colors hover:text-blue-600"
            >
              <IconMail size={14} />
              <span>help@stably.ai</span>
            </Anchor>
          </div>
        </div>
      </Modal>
      <div className="mb-4">
        <Slider
          restrictToMarks
          min={MARKS[0].value}
          max={MARKS.at(-1)!.value}
          scale={(idx) => MARKS[idx]?.label ?? 1}
          marks={MARKS}
          value={realValue}
          onChangeEnd={(value) => {
            if (value > maxIndex) {
              setIsModalOpen(true);
              onChange(max);
            }
          }}
          onChange={(value) => onChange(Math.pow(2, value))}
          {...props}
        />
        <Text
          className="mt-8 text-red-500 dark:text-red-400"
          size="sm"
        >
          {props.error}
        </Text>
      </div>
    </>
  );
}
